<template>
  <div class="flex h-full flex-col items-center justify-center space-y-4">
    <div
      class="flex h-18 w-18 items-center justify-center rounded-full bg-disabled"
    >
      <icon-base :icon="IconAgentsEmptyState" width="72" height="72" />
    </div>
    <div class="max-w-[350px] text-center">
      <span class="text-label">
        {{ $t("AI_AGENTS.EMPTY_STATE_CMD_K_TEXT") }}
      </span>
    </div>
  </div>
</template>
<script setup lang="ts">
import IconAgentsEmptyState from "@/components/icons/IconAgentsEmptyState.vue";
import IconBase from "@/components/ui/IconBase.vue";
</script>
